


import Search from '@/shared/components/search.component.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
        Search,
    },
})

export default class PartialSearch extends Vue {

    private handleInput(content: string) {
      //   console.log(content);
    }
}
